export const Errors = {
  google: {
    noTokenFound: 'No token found',
    errorWhileSendingPayment: 'Error while sending payment',
  },
  apple: {
    errorWhileSendingPayment: 'Error while sending payment',
  },
  global: {
    failedToSendPayment: 'Failed to send payment',
    genericError: 'An error occurred',
  },
  iframe: {
    failedToPostMessage: 'Failed to post message',
  },
  address: {
    errorFetchingAddresses: 'Error fetching addresses',
  },
  payment: {
    nuveiNotInitialized: 'Nuvei not initialized',
    nuveiDOMNotFound: 'Nuvei DOM elements not found',
    nuveiPaymentFailed: 'Nuvei payment failed',
    nuvei3DSFailed: 'Nuvei 3DS authentication failed',
    nuveiSettingsNotFound: 'Nuvei settings not found',
    adyenNotInitialized: 'Adyen not initialized',
    adyenDOMNotFound: 'Adyen DOM elements not found',
    adyenInitError: 'Adyen initialization error',
    adyenPaymentFailed: 'Adyen payment failed',
    adyenSettingsNotFound: 'Adyen settings not found',
    failedToImportAdyenCheckout: 'Failed to import AdyenCheckout',
    failedToInitializeGooglePay: 'Failed to initialize Google Pay',
    failedToInitializeApplePay: 'Failed to initialize Apple Pay',
    invalidRegexPattern: 'Invalid regex pattern',
    paymentFailed: 'Payment failed',
    stripeNotInitialized: 'Stripe or elements not initialized',
    submitError: 'Submit error',
    braintreeTokenizationError: 'Braintree tokenization error',
    braintreeNotInitialized: 'Braintree Hosted Fields not initialized',
    braintreeDOMNotFound: 'Braintree DOM elements not found',
    braintreeInitError: 'Braintree initialization error',
    emptyFields: 'Empty fields',
    invalidFields: 'Invalid fields',
    stripeCardNotInitialized: 'Stripe Card Element not initialized',
    noElementsOrSettings: 'No elements or provider settings or stripe',
    paymentMethodNotAvailable: "This payment method isn't available right now. Please choose another method.",
  },
  appchargeCardFailureReason: {
    missingPaymentMethodSettings: 'missing_payment_method_settings',
    missingCardElement: 'missing_card_element',
    validationFailed: 'validation_failed',
    collectFailed: 'collect_failed',
    unexpectedError: 'unexpected_error',
  },
  service: {
    unsupportedProvider: 'Unsupported provider',
    apiRequestFailed: 'API Request failed',
  },
};
